/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
  .none {
    fill: none !important;
  }
`

export default class ProfileIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="74.357" height="75.546" viewBox="0 0 74.357 75.546" css={Color}>
          <g transform="translate(-148.305 -254.089)">
            <path className="none" d="M186.2,254.089a20.745,20.745,0,1,1-20.745,20.745h0A20.745,20.745,0,0,1,186.2,254.089Z" fill="none" />
            <path d="M186.2,261.089a13.745,13.745,0,1,0,13.745,13.745A13.761,13.761,0,0,0,186.2,261.089m0-7a20.745,20.745,0,1,1-20.745,20.745A20.745,20.745,0,0,1,186.2,254.089Z" fill="#1c1f2b" /><path d="M219.161,329.635a3.5,3.5,0,0,1-3.5-3.453c0-.107-.289-11.6-7.378-19.591-4.841-5.454-12.9-8.458-22.7-8.458-9.007,0-17.054,3.1-22.078,8.516-7.65,8.239-8.2,19.508-8.2,19.621a3.5,3.5,0,0,1-6.995-.26c.02-.564.6-13.93,10.069-24.123,6.344-6.834,16.261-10.754,27.208-10.754,11.827,0,21.748,3.84,27.936,10.812,8.852,9.974,9.134,23.57,9.141,24.143a3.5,3.5,0,0,1-3.453,3.547Z" fill="#1c1f2b" />
          </g>
        </svg>
      </Fragment>
    )
  }
}
